export function ExclamationMark(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Icon / Exclamation Mark / Circle">
          <path
            id="Icon"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM19.8166 10.5993C19.7 9.20006 20.8042 8 22.2083 8H25.7917C27.1958 8 28.3 9.20006 28.1834 10.5993L26.5834 29.7993C26.4797 31.0432 25.4399 32 24.1917 32H23.8083C22.5601 32 21.5203 31.0432 21.4166 29.7993L19.8166 10.5993ZM21 37C21 35.3431 22.3431 34 24 34C25.6569 34 27 35.3431 27 37C27 38.6569 25.6569 40 24 40C22.3431 40 21 38.6569 21 37Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </div>
  );
}
